import React, { useState, useEffect, useCallback } from 'react'
import './Notification.css'

const Notification = ({ message, type = 'info', duration = 3000, onClose }) => {
  const [isVisible, setIsVisible] = useState(false)
  const [isLeaving, setIsLeaving] = useState(false)

  const handleClose = useCallback(() => {
    setIsLeaving(true)
    setTimeout(() => {
      setIsVisible(false)
      if (onClose) onClose()
    }, 300) // Tempo da animação de saída
  }, [onClose])

  useEffect(() => {
    if (message) {
      setIsVisible(true)
      setIsLeaving(false)
      
      if (!duration || duration <= 0) return undefined

      const timer = setTimeout(() => {
        handleClose()
      }, duration)

      return () => clearTimeout(timer)
    }
  }, [message, duration, handleClose])

  if (!isVisible) return null

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✅'
      case 'error':
        return '❌'
      case 'warning':
        return '⚠️'
      case 'info':
      default:
        return 'ℹ️'
    }
  }

  return (
    <div className={`notification ${type} ${isLeaving ? 'leaving' : ''}`}>
      <div className="notification-content">
        <span className="notification-icon">{getIcon()}</span>
        <span className="notification-message">{message}</span>
        <button 
          className="notification-close" 
          onClick={handleClose}
          title="Fechar notificação"
        >
          ×
        </button>
      </div>
    </div>
  )
}

export default Notification
